import { getAssertion, isCapacitorNative, passkeysSupported, postJson } from '../global/webauthnUtils'

export default function passkeyConfirm({ routes, csrf, messages = {} }) {
  const defaults = {
    confirmFailed: 'Passkey confirmation failed. Please confirm your password.',
    cancelledOrFailed: 'Passkey confirmation was cancelled or failed.'
  }

  return {
    routes,
    csrf,
    messages: { ...defaults, ...messages },
    supported: false,
    loading: false,
    isMobileApp: false,

    async init() {
      this.supported = await passkeysSupported()
      this.isMobileApp = isCapacitorNative()
    },

    async confirm() {
      if (this.loading) return
      this.loading = true

      try {
        const optRes = await postJson(this.routes.assertOptions, {}, this.csrf)
        if (!optRes.ok) {
          alert(this.messages.confirmFailed)
          return
        }

        const opts = await optRes.json()
        const serverOptions = opts.publicKey ?? opts
        const assertion = await getAssertion(serverOptions)

        const verifyRes = await postJson(this.routes.assert, assertion, this.csrf)
        if (!verifyRes.ok) {
          alert(this.messages.confirmFailed)
          return
        }

        const payload = await verifyRes.json()
        if (payload?.redirect) {
          window.location.href = payload.redirect
        } else {
          window.location.reload()
        }
      } catch (error) {
        console.warn('passkey confirm failed', error)
        alert(this.messages.cancelledOrFailed)
      } finally {
        this.loading = false
      }
    }
  }
}
